import { ActionTree } from 'vuex';
import { TCallResultType, TDirection } from '@/services/zoom_phone_types';
import { RootState, ZoomPhoneState } from '@/store/types';
import { types } from './mutations';

const actions: ActionTree<ZoomPhoneState, RootState> = {
  setOutboundCallingAction ({ commit }): void {
    commit(types.RESET_CALL_INFO);
    commit(types.SET_DIRECTION, 'outbound');
    commit(types.SET_IS_CALLING, true);
  },
  resetOutboundCallingAction ({ commit }): void {
    commit(types.RESET_CALL_INFO);
    commit(types.SET_DIRECTION, null);
    commit(types.SET_IS_CALLING, false);
  },
  setCallStartedInfoAction ({ commit }, args: { id: string, direction: TDirection, startedAt: string }): void {
    commit(types.SET_CALL_STARTED_INFO, args);
    commit(types.SET_DIRECTION, args.direction);
    commit(types.SET_IS_CALLING, true);
  },
  setCallConnectedInfoAction ({ commit }, args: { id: string, direction: TDirection, connectedAt: string }): void {
    commit(types.SET_CALL_CONNECTED_INFO, args);
    commit(types.SET_DIRECTION, args.direction);
    commit(types.SET_IS_CALLING, true);
  },
  setCallEndedInfoAction ({ commit }, args: { id: string, direction: TDirection, endedAt: string, result: TCallResultType }): void {
    commit(types.SET_CALL_ENDED_INFO, args);
    commit(types.SET_DIRECTION, args.direction);
    commit(types.SET_IS_CALLING, false);
  },
  resetZoomPhoneCallInfoAction ({ commit }): void {
    commit(types.RESET_CALL_INFO);
  },
};

export default {
  ...actions,
};
